import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rubiks.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2517d97b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Home", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rubiks Cube",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Test your arithmetic skills with this online game. ", -1))

import {
        LandingPagesComposable
    } from '@/interfaces'
    import useLandingPages from '@/composables/useLandingPages'
    import GenericButton from '@/elements/GenericButton.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const {
        playGame,
        readInstructions
    }: LandingPagesComposable = useLandingPages()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("aside", null, [
      _createVNode(GenericButton, {
        text: "Read Instructions",
        onClick: _unref(readInstructions)
      }, null, 8, ["onClick"]),
      _createVNode(GenericButton, {
        text: "Play Game",
        onClick: _unref(playGame)
      }, null, 8, ["onClick"])
    ])
  ]))
}
}

})